import { connect } from 'react-redux'
import UI from './UI'
import { push } from 'connected-react-router'
import { clearTrainerAction, fetchTrainerAction } from './store'
import { decorateUrl } from 'components/common/UTMscript'

const mapStateToProps = ({ trainer }) => ({
  firstName: trainer.FirstName,
  lastName: trainer.LastName,
  avatar: trainer.Photo,
  description: trainer.Description,
  metadataTitle: trainer.MetadataTitle,
  metadataDescription: trainer.MetadataDescription,
  testimony: trainer.Testimony,
  coursesCount: trainer.CoursesCount,
  studentsCount: trainer.StudentsCount,
  reviewsCount: trainer.ReviewsCount,
  creationDate: trainer.CreationDate,
  courses: trainer.Courses,
  position: trainer.Position,
  LinkedIn: trainer.LinkedIn,
  idTrainer: trainer.Id,
  loading: trainer.isLoading
})

const mapDispatchToProps = dispatch => ({
  FetchTrainer: (id) => dispatch(fetchTrainerAction(id)),
  goToLink: (url) => dispatch(push(decorateUrl(url))),
  clearTrainer: () => dispatch(clearTrainerAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
